import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-linkedin-callback',
  standalone: true,
  template: '<div style="display: flex; justify-content: center; align-items: center; height: 100vh;">Authenticating with LinkedIn...</div>'
})
export class LinkedinCallbackComponent implements OnInit {
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      const state = params['state'];
      const error = params['error'];
      const errorDescription = params['error_description'];

      if (code) {
      
        if (window.opener) {
          window.opener.postMessage(
            { type: 'linkedin-login-success', code: code, state: state },
            window.location.origin
          );
        }
      } else {
 
        if (window.opener) {
          window.opener.postMessage(
            { 
              type: 'linkedin-login-error', 
              message: errorDescription || error || 'LinkedIn login failed' 
            },
            window.location.origin
          );
        }
      }
    });
  }
}
